<div class="flex flex-col items-center">
  <div class="flex items-center content-center gap-x-6"
       [ngClass]="{'w-full': currentConfig.horizontal, ' min-h-[350px]' : !currentConfig.horizontal}">


    <!-- Start Drop Zone -->
    <div
      class="relative flex flex-col outline-gray-500 outline-2 -outline-offset-4 outline-dashed
       rounded-2xl items-center justify-center"
      [ngClass]="{ 'w-[350px] h-[350px]': !currentConfig.horizontal, 'w-full h-[150px]': currentConfig.horizontal }"
    >

      <div class="w-full absolute flex flex-col justify-center align-center items-center bg-opacity-70 bg-gray-50 rounded-2xl p-6" *ngIf="isUploading">
        <mat-progress-spinner
          class="my-4 w-1/12"
          [color]="'primary'"
          [mode]="'indeterminate'"
          [diameter]="50">
        </mat-progress-spinner>
        <span class="text-sm font-semibold text-primary">Uploading... Please wait</span>
      </div>

      <input
        #fileInput
        type="file"
        [multiple]="multiple"
        (change)="handleChange($event)"
        [accept]="acceptedFileMimeTypes"
        class="absolute w-full h-full cursor-pointer opacity-0 top-0 left-0"
      />

      <span class="mb-6" *ngIf="!currentConfig.noIcon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
             class="w-10 h-10">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
        </svg>
      </span>

      <p class="text-center text-base max-w-[90%] text-xs truncate" [innerHTML]="currentConfig.caption">
      </p>


      <button
        *ngIf="!currentConfig.noButton"
        type="button"
        (click)="fileInput.click()"
        class="z-10 mt-6 text-green-50 px-6 py-3 bg-green-500 rounded-lg font-medium text-base hover:bg-green-600 ease-in-out"
      >
        Browse File
      </button>
    </div>
    <!-- End Drop Zone -->

  </div>
</div>
